import { render, staticRenderFns } from "./detail_four.vue?vue&type=template&id=022b168a&scoped=true&"
import script from "./detail_four.vue?vue&type=script&lang=js&"
export * from "./detail_four.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022b168a",
  null
  
)

export default component.exports